export default __webpack_public_path__ + "static/media/blob_09.35ec3267.mp4";